module.exports = __webpack_public_path__ + "img/congratulations.13ee4350.png";